import { Component, OnInit, ElementRef, ViewChild } from '@angular/core';
import { IMember } from 'app/shared/Domains/member';
import { Router } from '@angular/router';
import { AppServiceManager } from 'common/services/appServiceManager';
import { BreadcrumbService } from 'app/breadcrumb.service';
import { MessageService, ConfirmationService } from 'primeng/api';
import { ICompany } from 'app/shared/Domains/company';
import { DatePipe } from '@angular/common';
import { IUser } from 'app/shared/Domains/IUser';
import { AuthService } from 'common/services/auth.service';
import { NgxUiLoaderService } from 'ngx-ui-loader';
import { forkJoin } from 'rxjs';
import { Configuration } from 'config/config';
import { NgxSpinnerService } from 'ngx-spinner';
import { IBranch } from 'app/shared/Domains/branch';
import { AppUtils } from 'common/services/app.util';
import { LanguageService } from 'app/LanguageService/Language.Service';
import { Asset } from 'app/shared/Domains/asset';
import { ExportDataComponent } from 'app/members/components/export-data/export-data.component';


@Component({
  selector: 'app-assets',
  templateUrl: './assets.component.html',
  styleUrls: ['./assets.component.css']
})
export class AssetsComponent implements OnInit {

  userRole: IUser;
  assets: Asset[];
  searchValue: any;
  loading: boolean = false;
  user: IUser;
  first: number = 0;
  sourceAssets: Asset[];
  sortedAssets: Asset[];
  copyArray: Asset[];
  asset: Asset;
  role: any;
  currentUserData: any;


  setLabel(label) {
    return this.LanguageService.GetCurrentLanguage("AssetsComponent", label);
  }

  constructor(
    private LanguageService: LanguageService,
    private route: Router,
    public config: Configuration,
    private ConfirmationService: ConfirmationService,
    private messageService: MessageService,
    private breadcrumbService: BreadcrumbService,
    private appServiceManager: AppServiceManager,
    private exportDataComponent: ExportDataComponent
  )
  {
    this.breadcrumbService.setItems([
      { label: 'Asset Management' },
      { label: 'Asset Management', routerLink: ['/add-assets'] }
    ]);
    this.LanguageService = LanguageService;
  }

  ngOnInit() {
    const currentUser = localStorage.getItem('currentUser');
    this.currentUserData = JSON.parse(currentUser);
    this.userRole = AuthService.getLoggedInRole();
    this.user = AuthService.getLoggedInUser();
    this.assets = [];
    this.asset = new Asset();
    this.role = AuthService.getLoggedInRole();
    Promise.resolve(this.getAssets())
    .then(() => {
      // Any additional logic after assets are loaded can go here
    })
    .finally(() => {
      this.loading = false;
    });


  }


  onPageChange(event) {
    this.first = event.first;
  }

  hotkeys($event) {
    if ($event.keyCode == 113) {
      this.route.navigateByUrl("/add-assets/add-assets");
      // let ele = document.getElementById("loginbtn");
      // ele.focus();
      // return
    }
  }


  getAssets(): Promise<void> {
    return new Promise((resolve, reject) => {
      this.appServiceManager.get('assets/company/' + this.user.company + '/branch/' + this.user.branch)
        .subscribe(
          (res: Asset[]) => {
            if (res.length > 0) {
              this.assets = [...res];
              this.sourceAssets = [...res];
            } else {
              this.assets = [];
              this.messageService.add({
                severity: 'info',
                summary: 'Info Message',
                detail: 'No Record Found'
              });
            }
            resolve();
          },
          (error) => {
            this.messageService.add({
              severity: 'error',
              summary: 'Error Message',
              detail: error.error.message,
            });
            reject(error);
          }
        );
    });
  }

  clear() {
    this.asset = new Asset();
    this.searchLocal("", "");
    this.first = 0;
  }

  compare(a, b) {
    const tagA = parseInt(a.tagNumber);
    const tagB = parseInt(b.tagNumber);
    let comparison = 0;
    if (tagA > tagB) {
      comparison = 1;
    } else if (tagA < tagB) {
      comparison = -1;
    }
    return comparison;
  }

  searchLocal(value, type) {
    let matchedName = [];
    let matchedTagNumber = [];
    let matchedContact = [];
    let matchedEmail = [];
    let matchedcardNo = [];
    let matchedOldSystemId = [];
    if (value !== null && value !== undefined && value.toString().length > 0) {
      if (value == "") {
        this.assets = Object.assign([], this.sourceAssets);
      }
      if (!value) {
        this.assets = Object.assign([], this.sourceAssets);
      }
      if (value != "") {
        if (type === "serialNumber") {
          matchedTagNumber = Object.assign([], this.sourceAssets).filter(
            cust => cust.serialNumber ? cust.serialNumber.indexOf(value) > -1 : null);
        } else if (type === "contact") {
          matchedContact  = Object.assign([], this.sourceAssets).filter(
            cust => cust.contactDetail.contact ? cust.contactDetail.contact.indexOf(value) > -1 : null);
        }
        else if(type === "oldSystemId") {
          matchedOldSystemId = Object.assign([], this.sourceAssets).filter(
            cust => cust.oldSystemId ? cust.oldSystemId.indexOf(value) > -1 : null);
        }
        else if (type === "cardNo") {
          matchedcardNo = Object.assign([], this.sourceAssets).filter(
            cust => cust.cardNo ? cust.cardNo.indexOf(value) > -1 : null);
        }
        else if (type === "email") {
          matchedEmail = Object.assign([], this.sourceAssets).filter(
            cust => cust.email ? cust.email.toLowerCase().indexOf(value.toLowerCase()) > -1 : null);
        }
        else {
          matchedName = Object.assign([], this.sourceAssets).filter(
            cust => cust.name ? cust.name.toLowerCase().indexOf(value.toLowerCase()) > -1 : null);
        }
        const distinct = (value, index, self) => {
          return self.indexOf(value) === index;
        }
        const source = matchedName.concat(matchedTagNumber, matchedContact, matchedEmail, matchedcardNo, matchedOldSystemId);
        this.assets = source.filter(distinct);

        if (this.assets.length === 0) {
          this.assets = [];
          this.messageService.clear();
          this.messageService.add({ severity: 'info', summary: 'Info Message', detail: 'No Record Found' });
        } else {
          this.first = 0;
          if (this.assets.length === 1) {
            this.first = 0;
          }
          this.assets = [...this.assets];
          this.assets.sort(this.compare);
        }
      }
    } else {
      this.assets = Object.assign([], this.sourceAssets);
      this.assets = [...this.assets];
    }
  }

  viewAsset(asset) {
    this.route.navigateByUrl('assets/asset/' + asset._id)
  }


}
